import React from 'react';
import { useIntl } from 'react-intl';

import { renderWithBreaks } from '@utils/translations';

const RefundPolicyTab = () => {
  const intl = useIntl();

  return (
    <div>
      <h3>{intl.formatMessage({ id: '1. Our Refund Policy'})}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Refund Policy 1' }))}
    </div>
  );
}

export default RefundPolicyTab;
